export var IBrandViewV2Response;
(function (IBrandViewV2Response) {
    let ILeanBrand;
    (function (ILeanBrand) {
        /**
         * Return an instance of ILeanBrand with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        ILeanBrand.build = (partial) => (Object.assign({ active_promo_collections: [], badges: [], story_images: [], tags: [], social_media_images: [] }, (partial !== null && partial !== void 0 ? partial : {})));
    })(ILeanBrand = IBrandViewV2Response.ILeanBrand || (IBrandViewV2Response.ILeanBrand = {}));
    /**
     * Return an instance of IBrandViewV2Response with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IBrandViewV2Response.build = (partial) => (Object.assign({ banners: [], related_search_terms: [], brand_videos: [], active_season_years: [], info_texts: [], faire_funded_promo: [], highlighted_apparel_seasons_for_promotional_event: [], promo_display_texts: [] }, (partial !== null && partial !== void 0 ? partial : {})));
})(IBrandViewV2Response || (IBrandViewV2Response = {}));
